// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   Assessment Detail Skeleton
   Mirrors detail-page CSS from assessment-detail.component.css
   ========================================================= */

:host {
  display: block;
}

/* ── App info card ── */
.skl-app-info-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.skl-info-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 12px 16px;
}

.skl-info-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  border-bottom: 1px solid #D0CADE;
  padding: 8px 0;
}

.skl-info-row--last {
  border-bottom: none;
}

.skl-info-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* ── Analysis cards ── */
.skl-analysis-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: 100%;
}

.skl-analysis-header {
  padding: 12px 16px;
  border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
}

.skl-analysis-header--blue {
  background: #0066B2;
}

/* Blue shimmer Back button placeholder */
.skl-btn-back-placeholder {
  width: 60px;
  height: 38px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    #0066B2 25%,
    #1a7cc9 50%,
    #0066B2 75%
  );
  background-size: 200% 100%;
  animation: shimmer-blue 1.5s ease-in-out infinite;
  flex-shrink: 0;
}

@keyframes shimmer-blue {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

/* White shimmer override for header text inside blue bg */
.skl-header-bar-white ::ng-deep .skeleton-block {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.25) 25%,
    rgba(255, 255, 255, 0.45) 50%,
    rgba(255, 255, 255, 0.25) 75%
  ) !important;
  background-size: 200% 100% !important;
}

.skl-analysis-content {
  padding: 16px;
}

.skl-analysis-row {
  display: flex;
  gap: 16px;
}

.skl-analysis-item {
  flex: 1;
}

/* ── Details section ── */
.skl-details-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.skl-details-body {
  padding: 16px;
}

/* Dimension table rows */
.skl-dim-header-row {
  display: grid;
  grid-template-columns: 2fr 1fr 3fr;
  gap: 12px;
  padding: 10px 12px;
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.skl-dim-row {
  display: grid;
  grid-template-columns: 2fr 1fr 3fr;
  gap: 12px;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  min-height: 48px;
}

.skl-dim-reasoning {
  display: flex;
  flex-direction: column;
}

/* Radar chart placeholder */
.skl-radar-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
}

.skl-radar-circle {
  width: 260px;
  height: 260px;
  border-radius: 50%;
  background: #e9ecef;
  position: relative;
}

.skl-radar-circle::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: #f4f5f7;
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/assessments/assessment-detail-skeleton/assessment-detail-skeleton.component.css"],"names":[],"mappings":"AAAA;;;8DAG8D;;AAE9D;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,0DAA0D;AAC1D;EACE;;;;;cAKY;EACZ,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["/* =========================================================\n   Assessment Detail Skeleton\n   Mirrors detail-page CSS from assessment-detail.component.css\n   ========================================================= */\n\n:host {\n  display: block;\n}\n\n/* ── App info card ── */\n.skl-app-info-section {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.skl-info-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 12px 16px;\n}\n\n.skl-info-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  border-bottom: 1px solid #D0CADE;\n  padding: 8px 0;\n}\n\n.skl-info-row--last {\n  border-bottom: none;\n}\n\n.skl-info-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* ── Analysis cards ── */\n.skl-analysis-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  height: 100%;\n}\n\n.skl-analysis-header {\n  padding: 12px 16px;\n  border-radius: 8px 8px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n}\n\n.skl-analysis-header--blue {\n  background: #0066B2;\n}\n\n/* Blue shimmer Back button placeholder */\n.skl-btn-back-placeholder {\n  width: 60px;\n  height: 38px;\n  border-radius: 4px;\n  background: linear-gradient(\n    90deg,\n    #0066B2 25%,\n    #1a7cc9 50%,\n    #0066B2 75%\n  );\n  background-size: 200% 100%;\n  animation: shimmer-blue 1.5s ease-in-out infinite;\n  flex-shrink: 0;\n}\n\n@keyframes shimmer-blue {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n/* White shimmer override for header text inside blue bg */\n.skl-header-bar-white ::ng-deep .skeleton-block {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.25) 25%,\n    rgba(255, 255, 255, 0.45) 50%,\n    rgba(255, 255, 255, 0.25) 75%\n  ) !important;\n  background-size: 200% 100% !important;\n}\n\n.skl-analysis-content {\n  padding: 16px;\n}\n\n.skl-analysis-row {\n  display: flex;\n  gap: 16px;\n}\n\n.skl-analysis-item {\n  flex: 1;\n}\n\n/* ── Details section ── */\n.skl-details-section {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.skl-details-body {\n  padding: 16px;\n}\n\n/* Dimension table rows */\n.skl-dim-header-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 3fr;\n  gap: 12px;\n  padding: 10px 12px;\n  background: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.skl-dim-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 3fr;\n  gap: 12px;\n  align-items: center;\n  padding: 10px 12px;\n  border-bottom: 1px solid #f0f0f0;\n  min-height: 48px;\n}\n\n.skl-dim-reasoning {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Radar chart placeholder */\n.skl-radar-wrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 0;\n}\n\n.skl-radar-circle {\n  width: 260px;\n  height: 260px;\n  border-radius: 50%;\n  background: #e9ecef;\n  position: relative;\n}\n\n.skl-radar-circle::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 130px;\n  height: 130px;\n  border-radius: 50%;\n  background: #f4f5f7;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
